import { Injectable } from "@angular/core";
import { ValidatorFn, Validators } from "@angular/forms";
import { AssessmentValidator } from "@obg/ngx.common";
import { OBG_VALIDATORS } from "@obg/ngx.ui.common";

import { CombinedValidator } from "./customer-assessments.model";

@Injectable()
export class CustomerAssessmentsValidatorService {
	validators: CombinedValidator = this.combineValidators();

	createValidators(answerValidators: AssessmentValidator[]): ValidatorFn[] {
		return answerValidators
			.map((answerValidator) =>
				answerValidator.value
					? this.validators.parameterValidators?.[answerValidator.validator]?.(answerValidator.value)
					: this.validators.nonParameterValidators?.[answerValidator.validator]
			)
			.filter(Boolean);
	}

	private combineValidators(): CombinedValidator {
		const currencyAmount = OBG_VALIDATORS.currencyAmount("currencyAmount");
		const { email, max, maxLength, min, minLength, required } = Validators;
		const {
			compareContains,
			containsDate,
			duplicationCheck,
			matchesRegex,
			nationalId,
			nonNumeric,
			numberBiggerOrEqual,
			numberSmallerOrEqual,
			numeric,
			numericNotZero,
			username,
			whitespaceForNonRequired,
		} = OBG_VALIDATORS;

		return {
			nonParameterValidators: {
				containsDate,
				currencyAmount,
				email,
				nonNumeric,
				numeric,
				numericNotZero,
				required,
				username,
				whitespace: whitespaceForNonRequired,
			},
			parameterValidators: {
				compareContains,
				duplicationCheck,
				matchesRegex,
				max,
				maxLength,
				min,
				minLength,
				nationalId,
				numberBiggerOrEqual,
				numberSmallerOrEqual,
			},
		};
	}
}
